import '../styles/main.css';

import "slick-carousel";
import jQuery from "jquery";
window.jQuery = window.$ = jQuery;

import './theme/index';
import './global/index';
import './sections/index';
import './components/index';
